import { render, staticRenderFns } from "./ImageWithLightbox.vue?vue&type=template&id=61e8614c"
import script from "./ImageWithLightbox.vue?vue&type=script&lang=js"
export * from "./ImageWithLightbox.vue?vue&type=script&lang=js"
import style0 from "./ImageWithLightbox.vue?vue&type=style&index=0&id=61e8614c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports